import React from 'react'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'
import { useStyles } from './styles.css'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from '@material-ui/core'
import { Trans } from 'react-i18next'
import { SlateCategory } from '@sugg-gestion/ubidreams-react-suggpro'
import FoodTypeForm, { FoodTypeFormState } from 'components/forms/establishment/foodTypeForm'
import CloseButton from 'components/dialogs/closeButton'

interface Props {
    open: boolean
    onClose: () => void
    onSubmit: (values: FoodTypeFormState) => void
    inProgress: boolean
    initialValues: FoodTypeFormState
    categories?: Array<SlateCategory>
}

const EstablishmentFoodTypeDialogView: React.FC<Props> = ({ open, onClose, inProgress, ...formData }) => {
    const classes = useStyles()

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            scroll="paper"
            classes={{
                paper: classes.paper,
            }}
            maxWidth="md"
        >
            <FoodTypeForm formClassName={classes.form} inProgress={inProgress} {...formData}>
                {(content, actions) => (
                    <>
                        <DialogTitle>
                            <Trans i18nKey="views.establishment.foodType.subtitle" />
                        </DialogTitle>
                        <DialogContent dividers>
                            <CloseButton onClose={onClose} />
                            {content}
                        </DialogContent>
                        <DialogActions className={classes.actions}>
                            <Button variant="contained" onClick={onClose}>
                                <Trans i18nKey="actions.cancel" />
                            </Button>
                            {actions.map((action, index) => (
                                <SubmitButton
                                    key={index}
                                    variant="contained"
                                    color="primary"
                                    {...action}
                                    className={clsx(action.className)}
                                >
                                    <Trans i18nKey="actions.validate" />
                                </SubmitButton>
                            ))}
                        </DialogActions>
                    </>
                )}
            </FoodTypeForm>
        </Dialog>
    )
}

export default EstablishmentFoodTypeDialogView
